import * as Sentry from "@sentry/browser";
import { getParameterByName } from "../../../getParameters";
import GameVersion from "../../Singleton/versionSingleton";

export function configureAndInitilizeSentry() {
  const hostname = window.location.hostname;
  // // Check if the current environment is localhost
  const PROMO_BRAND = getHomeUrlAsBrand();
  let PROMO_ENV = process.env.NODE_ENV; //
  if (hostname.includes("dev.") && PROMO_ENV === "production") {
    PROMO_ENV = "development";
  }
  let PROMO_SENTRYACTIVATE = false;
  if (
    process.env.NODE_ENV === "production" ||
    process.env.NODE_ENV === "development"
  ) {
    if (hostname !== "localhost") {
      PROMO_SENTRYACTIVATE = true; //
    }
  }

  const GAME_VERSION = GameVersion.getInstance().version;
  const GAME_MARKETID = getParameterByName("marketId");
  const GAME_PLATFORMTYPE = getParameterByName("platformType");

  const releaseProductType = "gameClient@";
  const version = GameVersion.getInstance().version; // Your app's version
  // Combining version and commit hash as the release name
  const releaseName = `${releaseProductType}:${version}`;
  Sentry.init({
    release: releaseName,
    dsn:
      "https://66f8074ad0bc8a4803e018935ea517c8@o4505466371768320.ingest.us.sentry.io/4508256446578688",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.globalHandlersIntegration({
        onerror: true, // capture uncaught errors
        onunhandledrejection: true, // capture unhandled promise rejections
      }),
      Sentry.replayCanvasIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1, // Capture 100% of the transactions
    enabled: PROMO_SENTRYACTIVATE,
    tracePropagationTargets: [
      hostname,
      new RegExp(`^http:\/\/${hostname}`), // Properly use string interpolation for regex
    ],
    // Session Replay
    replaysSessionSampleRate: 0, // This sets the sample rate at 100% in dev
    replaysOnErrorSampleRate: 0.001, // Sample all sessions when errors occur
    // Environment settings
    environment: PROMO_ENV,
    debug: false, // Enable Sentry debug logging on development
  });

  // Get version number and set global context for Sentry
  Sentry.setContext("Game Context", {
    version: GAME_VERSION,
    brand: PROMO_BRAND,
    marketId: GAME_MARKETID,
    platformType: GAME_PLATFORMTYPE,
  });

  //   // Event listener for Spacebar press
  //   document.addEventListener("keydown", (event) => {
  //     if (event.code === "Space") {
  //       // Trigger a test error when Spacebar is pressed
  //       console.log("Sentry Test Error triggered!", GAME_VERSION);
  //       // Sentry.captureException(
  //       //   new Error("Test error triggered by Space key press" + Date.now())
  //       // );
  //     }
  //   });
}

function getHomeUrlAsBrand() {
  const url = decodeURIComponent(getParameterByName("homeUrl"));
  const regex = /(?:https?:\/\/)?(?:www\.)?([^\.]+)\.([^\.]+\.[^\/]+)/;
  const result = url.match(regex);

  if (result && result.length > 2) {
    const subdomain = result[1];
    const domain = result[2];
    const fullDomain = subdomain + "." + domain;
    return fullDomain; // Output: dev.starcasino
  } else {
    return "Unknown";
  }
}
